import { Chapter, ChapterLesson, Course } from "@jelly/lesson";
import { Button } from "@jelly/ui";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import styles from "../CourseWelcome.module.scss";
import appConfig from "appConfig";

interface CourseWelcomeIntroViewProps {
  courseId: string;
  course: Course;
  chapters: Chapter[];
  firstLesson: ChapterLesson;
}

const CourseWelcomeIntroView: React.FC<CourseWelcomeIntroViewProps> = (props) => {
  const logoUrl = appConfig.ASSETS_URL + "/eu-logo.jpg";

  useEffect(() => {
    if (props.course) {
      document.title = `ASKNow - Course ${props.course.publicId} welcome page`;
    }
  }, [props.course]);

  return (
    <>
      <h1>{props.course.name}</h1>
      <p>{props.course.description}</p>
      <div className={styles.content}>
        <Link to={`/course/${props.courseId}/${props.firstLesson.lesson.id}`}>
          <Button
            className={styles.firstLessonButton}
            icon="cis-running"
            iconPlacement="right"
            shape="round"
            theme="secondary"
          >
            Go to Lesson {props.course.publicId}.1
          </Button>
        </Link>
      </div>
      <div className={styles.bottom}>
        <img src={logoUrl} alt="Co-founded by the European Union" />
      </div>
    </>
  );
};

export default CourseWelcomeIntroView;
